module.exports = __webpack_public_path__ + "img/solution-dil-system-pic-4.b80f1738.png";